import "reflect-metadata";
import { setup } from "@/setup";
import Vue from "vue";
import App from "@/App.vue";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";

setup();

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
